import { useState, useEffect, useRef, useMemo } from "react";
import { Button, Col, Modal, Nav, Row, Tab, Form } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import { debounce } from "lodash";

import {
  getLocalCalendarDate,
  formatCalendarDate,
  formatCalendarDateForInput,
  formatPhoneNumber,
  getCaseId,
  getClientId,
  inputCurrencyFormat2,
} from "../../../Utils/helper";
import { api_without_cancellation } from "../../../api/api";
import AutoCompleteSearch from "../../Insurance/AutoCompleteSearch";

import GenericContactTabForHookForm from "./GenericContactTabForHookForm";
import CaseWorkerSelection from "./CaseWorkersSelectionModal";

const NewReportModal = ({ show, handleClose, fetchReports, isDummy }) => {
  //Rk2024265450
  const origin = process.env.REACT_APP_BACKEND_URL;

  const methods = useForm();
  const { reset, handleSubmit, register, setValue, watch } = methods;

  const [searchResults, setSearchResults] = useState([]); // Reports
  // const [filteredResults, setfilteredResults] = useState([]); //filteredReports
  const [statesAbrs, setStatesAbrs] = useState([]); //state abrs
  const [reportTypes, setReportTypes] = useState([]); // all reports in db
  const [dummy, setDummy] = useState(false);
  // const [isFiltersOpen, setIsFiltersOpen] = useState(false);
  const [selectedReportTypeID, setSelectedReportTypeID] = useState(1);
  const reportTypeRef = useRef(null);
  const [reportTypeDropdown, setReportTypeDropdown] = useState(false);
  const [firmUsers, setFirmUsers] = useState([]);
  const [otherFirmUser, setOtherFirmUsers] = useState([]);
  useEffect(() => {
    if (isDummy) {
      setValue("is_blocked", isDummy);
      setDummy(isDummy);
    }
  }, [isDummy]);
  useEffect(() => {
    const fetchCaseWorkers = async () => {
      try {
        const res = await api_without_cancellation.get(
          "/api/tasks-page/case_workers_and_other_firm_users/",
          {
            params: {
              case_id: getCaseId(),
            },
          }
        );
        const data = await res.data;
        setFirmUsers(
          data.case_role_users.map((worker) => ({
            firm_user: worker,
          }))
        );
        setOtherFirmUsers(
          data.other_firm_users.map((worker) => ({
            firm_user: worker,
          }))
        );
      } catch (error) {
        console.error(error);
      }
    };

    fetchCaseWorkers();
  }, []);
  const fetchReportTypes = async () => {
    try {
      const response = await api_without_cancellation.get(`${origin}/api/report_types/`);
      if (response.status === 200) {
        setReportTypes(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchSatesData = async () => {
    try {
      const response = await api_without_cancellation.get(`${origin}/api/states/`);
      if (response.status === 200) {
        setStatesAbrs(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // const fetchFilterReportData = async () => {
  //   try {
  //     const response = await api_without_cancellation.get("/api/search_filter_reports/");
  //     if (response.status === 200) {
  //       setSearchResults(response.data);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };
  const [reportSearchInput, setReportSearchInput] = useState("");
  const controllerRef = useRef(null);

  const fetchFilterReportData = async (search) => {
    try {
      if (controllerRef.current) {
        controllerRef.current.abort();
      }

      const controller = new AbortController();
      controllerRef.current = controller;

      const params = { query: search };

      const response = await api_without_cancellation.get("/api/search_filter_reports/", {
        params,
        signal: controller.signal,
      });

      const data = response.data;

      setSearchResults(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const debouncedFilterReport = useMemo(
    () => debounce((search) => fetchFilterReportData(search), 400),
    []
  );
  const handleSearch = (event) => {
    const search_input_report = event.target.value;

    if (search_input_report.length >= 2) {
      debouncedFilterReport(search_input_report);
    } else {
      debouncedFilterReport.cancel();
      if (controllerRef.current) {
        controllerRef.current.abort();
      }
      setSearchResults([]);
    }
  };

  useEffect(() => {
    fetchSatesData();
    fetchReportTypes();
  }, [origin]);

  useEffect(() => {
    const handler = (e) => {
      if (reportTypeRef.current && !reportTypeRef.current.contains(e.target)) {
        setReportTypeDropdown(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  useEffect(() => {
    setValue("report_typeID", selectedReportTypeID);
  }, [selectedReportTypeID, setValue]);

  // const handleInputChange = (e) => {
  //   const inputValue = e.target.value.toLowerCase();
  //   if (inputValue !== "") {
  //     const filtered = searchResults?.filter((result) => {
  //       const agency = result.name ? result.name.toLowerCase() : "";
  //       const address1 = result.address1 ? result.address1.toLowerCase() : "";
  //       const address2 = result.address2 ? result.address2.toLowerCase() : "";
  //       const city = result.city ? result.city.toLowerCase() : "";
  //       const state = result.state ? result.state.toLowerCase() : "";

  //       return (
  //         agency.startsWith(inputValue) ||
  //         address1.startsWith(inputValue) ||
  //         address2.startsWith(inputValue) ||
  //         city.startsWith(inputValue) ||
  //         state.startsWith(inputValue)
  //       );
  //     });

  //     setfilteredResults(filtered);
  //     setIsFiltersOpen(true);
  //   } else {
  //     setfilteredResults("");
  //   }
  // };

  //set Report Data in form inputs
  const handleSelectAgency = (reportingAgency) => {
    setValue("reporting_agency_name", reportingAgency.reporting_agency);
    setValue("address", reportingAgency.address1);
    setValue("address1", reportingAgency.address2);
    setValue("city", reportingAgency.city);
    setValue("state", reportingAgency.state);
    setValue("zip", reportingAgency.zip);
    setValue("email", reportingAgency.email);
    setValue("phone", formatPhoneNumber(reportingAgency.phone));
    setValue("extension", reportingAgency.extension);
    setValue("fax", formatPhoneNumber(reportingAgency.fax));
    setValue("website", reportingAgency.website);
    setValue("contact_title", reportingAgency.contact_title);
    setValue("reporter_firstname", reportingAgency.contact_first_name);
    setValue("reporter_lastname", reportingAgency.contact_last_name);
    setSearchResults([]);
  };

  const sendDataToCreateReport = async (data) => {
    data.completed = data.completed || null;
    if (data.report_taken) {
      data.date_taken = getLocalCalendarDate();
    }

    data.dummy = dummy;
    const uniqueWorkerIds = [...new Set(uniqueIdUsers)];
    data.workers_on_reports = uniqueWorkerIds;
    try {
      const response = await api_without_cancellation.post(
        `${origin}/api/add_new_report/${getClientId()}/${getCaseId()}/`,
        data
      );
      if (response.status === 201) {
        handleClose();
        reset();
        fetchReports();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const onSubmit = (data) => {
    // onUpdate();
    sendDataToCreateReport(data);
  };
  const selectedReportType = reportTypes?.find((rt) => rt.id === selectedReportTypeID);
  const [showOtherUsersModal, setShowOtherUsersModal] = useState(false);

  const [assignedUsers, setAssignedUsers] = useState([]);
  const [uniqueIdUsers, setUniqueIdUsers] = useState([]);
  const [costFocused, setCostFocused] = useState(false);
  const costValue = watch("cost");
  const readyDate = watch("completed");
  const requestedDate = watch("report_requested");
  const receivedDate = watch("report_received");
  const reminderLabel = useMemo(() => {
    const fmt = (d) => formatCalendarDate(d);
    const addDays = (d, n) => {
      const [year, month, day] = formatCalendarDateForInput(d).split("-").map(Number);
      const x = new Date(year, month - 1, day);
      x.setDate(x.getDate() + n);
      return getLocalCalendarDate(x);
    };

    if (receivedDate) {
      return `ADD TASK TO REVIEW REPORT RECEIVED ON ${fmt(receivedDate)}`;
    }
    if (requestedDate) {
      return `Add Reminder Task to Check if Received by ${fmt(addDays(requestedDate, 14))} (Requested ${fmt(requestedDate)})`;
    }
    if (readyDate) {
      return `Add Reminder Task to Check Availability on Ready Date of ${fmt(readyDate)}`;
    }
    return "Add Reminder Task to Check Availability on Ready Date";
  }, [readyDate, requestedDate, receivedDate]);

  const [previousCost, setPreviousCost] = useState("");
  return (
    <FormProvider {...methods}>
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="modal-dialog-centered max-800p content-add-report-to-case custom-insurance-dialog"
        contentClassName="content-add-report-to-case"
      >
        <div>
          <Modal.Header
            style={{ borderBottom: "0px" }}
            className="text-center height-25 p-0 bg-primary popup-heading-color justify-content-center"
          >
            <Modal.Title
              className="mx-auto height-25 font-weight-semibold text-uppercase popup-heading-color d-flex align-items-center"
              style={{ fontSize: "14px", fontWeight: "600" }}
            >
              Add Report to Case
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-0 ">
            <div className="custom-tab custom-margin-top">
              <Col md={12} className="d-flex p-0 justify-content-center align-items-center m-b-5">
                <input
                  type="checkbox"
                  id="dummy_defendant"
                  {...register("is_blocked")}
                  onChange={(e) => setDummy(e.target.checked)}
                  style={{ marginRight: "5px" }}
                />
                <label
                  className="mb-0"
                  style={{
                    textTransform: "uppercase",
                    fontWeight: "600",
                    color: dummy ? "black" : "var(--primary-25)",
                  }}
                >
                  {" "}
                  No Reports on Case
                </label>
              </Col>

              <Tab.Container defaultActiveKey={"report-information"}>
                <Nav variant="tabs" className="justify-content-around">
                  <Nav.Link
                    className="new-provider-nav-link-hover-effect nav-link Pad8 tab-ite apply-before"
                    eventKey="report-information"
                  >
                    Report Information
                  </Nav.Link>

                  <Nav.Link
                    className="new-provider-nav-link-hover-effect nav-link Pad8 tab-ite"
                    eventKey="reporting-agency"
                  >
                    Reporting Agency
                  </Nav.Link>

                  <Nav.Link
                    className="new-provider-nav-link-hover-effect nav-link Pad8 tab-ite apply-after"
                    eventKey="report-taken-by"
                  >
                    Report Taken By
                  </Nav.Link>
                </Nav>
                <Form
                  id="Reports_form "
                  className="d-flex flex-column justify-content-between"
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <div
                    style={{
                      minHeight: "350px",
                    }}
                    className="custom-margin-top "
                  >
                    <fieldset
                      disabled={dummy}
                      style={{
                        border: 0,
                        padding: 0,
                        margin: 0,
                        opacity: dummy ? 0.5 : 1,
                        pointerEvents: dummy ? "none" : "auto",
                      }}
                    >
                      <Tab.Content>
                        <Tab.Pane
                          style={{
                            minHeight: "350px",
                            overflow: "hidden",
                          }}
                          eventKey="reporting-agency"
                        >
                          <Row
                            style={{
                              paddingLeft: "0px",
                              paddingRight: "0px",
                            }}
                            className="d-flex mx-0"
                          >
                            <Col md={12} style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                              <input
                                type="text"
                                placeholder="Type Reporting agency name or address to search directory then click an entry"
                                className="form-control m-b-5 height-25 p-0 p-l-5 rounded-0"
                                name="reporting_agency_search_form"
                                value={reportSearchInput}
                                onChange={(e) => {
                                  setReportSearchInput(e.target.value);
                                  handleSearch(e);
                                }}
                              />
                              {reportSearchInput && (
                                <span
                                  onClick={() => {
                                    setReportSearchInput("");
                                    handleSearch({ target: { value: "" } });
                                    reset({
                                      reporting_agency_name: "",
                                      address: "",
                                      address1: "",
                                      city: "",
                                      state: "",
                                      zip: "",
                                      email: "",
                                      phone: "",
                                      extension: "",
                                      fax: "",
                                      website: "",
                                      contact_title: "",
                                      reporter_firstname: "",
                                      reporter_lastname: "",
                                    });
                                    setSelectedReportTypeID(Number(0));
                                  }}
                                  style={{
                                    position: "absolute",
                                    right: "15px",
                                    top: "5px",
                                    cursor: "pointer",
                                    fontSize: "14px",
                                    color: "black",
                                    lineHeight: 1,
                                    userSelect: "none",
                                  }}
                                >
                                  ✕
                                </span>
                              )}
                              {searchResults.length > 0 && (
                                <AutoCompleteSearch
                                  searchedInsurances={searchResults}
                                  selectedInsurance={(data) => handleSelectAgency(data)}
                                  isReport2={true}
                                />
                              )}
                              {/* {Array.isArray(filteredResults) && filteredResults.length > 0 && (
                              <div style={{ position: "relative" }}>
                                <div
                                  className={`${isFiltersOpen ? "block" : "hidden"}`}
                                  style={{
                                    position: "absolute",
                                    zIndex: 1000,
                                    backgroundColor: "#fff",
                                    border: "1px solid #ccc",
                                    width: "100%",
                                    maxHeight: "150px",
                                    overflowY: "auto",
                                  }}
                                >
                                  {filteredResults.map((result, index) => (
                                    <div
                                      key={index}
                                      onClick={() => {
                                        handleSelectAgency(result);
                                        setIsFiltersOpen(false);
                                      }}
                                      style={{
                                        padding: "8px",
                                        cursor: "pointer",
                                        borderBottom: "1px solid #ddd",
                                      }}
                                    >
                                      {result.name} {result.address1} {result.address2}{" "}
                                      {result.city} {result.state}
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )} */}
                            </Col>
                          </Row>
                          <Row className="mx-0 align-items-center custom-margin-bottom">
                            <Col md={12} className="p-0">
                              <div className="row mx-0 align-items-center custom-margin-bottom">
                                <div className="col-md-12 p-l-5 p-r-5">
                                  <input
                                    type="text"
                                    placeholder="Enter Reporting Agency"
                                    className="form-control height-25 p-l-5 p-0 d-flex align-items-center justify-content-center"
                                    {...register("reporting_agency_name")}
                                  />
                                </div>
                              </div>
                              <GenericContactTabForHookForm
                                statesAbrs={statesAbrs}
                                // selectedState={selectedState.current}
                              />
                            </Col>
                          </Row>
                        </Tab.Pane>

                        {/* Report Information Completed */}
                        <Tab.Pane
                          style={{
                            minHeight: "350px",
                          }}
                          eventKey="report-information"
                        >
                          <Row
                            style={{
                              minHeight: "350px",
                            }}
                            className="mx-0 d-flex"
                          >
                            <Col md={12} className="p-0">
                              {/* <div className="row mx-0 align-items-center custom-margin-bottom">
                              <div className="col-md-12">
                                <select
                                  className="form-select form-control height-25 d-f"
                                  {...register("report_typeID")}
                                >
                                  {reportTypes &&
                                    reportTypes.map((reportType) => (
                                      <option
                                        key={reportType.id}
                                        value={reportType.id}
                                        selected={reportType.id === selectedReportTypeID}
                                      >
                                        {reportType.name}
                                      </option>
                                    ))}
                                </select>
                              </div>
                            </div> */}
                              <div className="d-flex mx-0 align-items-center custom-margin-bottom">
                                <div
                                  ref={reportTypeRef}
                                  className="col-md-5  p-l-5 p-r-5  custom-select-new-provider"
                                  style={{
                                    position: "relative",
                                  }}
                                >
                                  <div
                                    className="dropdown-button form-control pt-0 pb-0 pe-0 rounded-0 height-25 d-flex align-items-center"
                                    onClick={() => setReportTypeDropdown((p) => !p)}
                                    style={{
                                      paddingLeft: selectedReportType ? "0px" : "5px",
                                      background: "white",
                                    }}
                                  >
                                    <span>
                                      {selectedReportType ? (
                                        <div
                                          className="d-flex p-l-5 align-items-center"
                                          style={{
                                            height: "25px",
                                            fontSize: "14px",
                                            color: "black",
                                            fontWeight: "700",
                                          }}
                                        >
                                          {selectedReportType.name}
                                        </div>
                                      ) : (
                                        "Select Report Type"
                                      )}
                                    </span>
                                  </div>
                                  {reportTypeDropdown && (
                                    <div
                                      className="dropdown-menu p-0 mt-0"
                                      style={{
                                        width: "281.66px",
                                        left: "5px",
                                        border: "1px solid #ced4da",
                                        // minHeight: "150px",
                                        // maxHeight: "550px",
                                        fontSize: "14px",
                                        overflowY: "auto",
                                        scrollbarWidth: "none",
                                      }}
                                    >
                                      {reportTypes?.map((rt) => (
                                        <div
                                          key={rt.id}
                                          className="dropdown-option d-flex align-items-center height-25"
                                          style={{
                                            cursor: "pointer",
                                            paddingLeft: "5px",
                                            fontWeight: "700",
                                          }}
                                          onClick={() => {
                                            setSelectedReportTypeID(rt.id);
                                            setReportTypeDropdown(false);
                                            setValue("report_typeID", rt?.id);
                                          }}
                                        >
                                          {rt.name}
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </div>
                                <div
                                  className="d-flex ps-0 p-r-5 align-items-center justify-content-start"
                                  style={{
                                    color: "var(--primary-25)",
                                    fontWeight: "600",
                                    // width: "135px",
                                  }}
                                >
                                  Report&nbsp;#:
                                </div>
                                <div className="flex-g-1 height-25 ps-0 p-r-5">
                                  <input
                                    type="text"
                                    placeholder="Report Number"
                                    className="form-control height-25 p-0 p-l-5 rounded-0"
                                    onFocus={(e) => {
                                      e.target.placeholder = "";
                                      e.target.style.color = "black";
                                    }}
                                    onBlur={(e) => {
                                      e.target.placeholder = "Report Number";
                                    }}
                                    style={{ color: "var(--primary-25)" }}
                                    {...register("report_number")}
                                  />
                                </div>
                                <div
                                  className="d-flex  ps-0 p-r-5 align-items-center justify-content-start"
                                  style={{
                                    color: "var(--primary-25)",
                                    fontWeight: "600",
                                    // width: "135px",
                                  }}
                                >
                                  Cost:
                                </div>
                                <div
                                  className="height-25 p-l-0 p-r-5"
                                  style={{
                                    width: "110px",
                                  }}
                                >
                                  {/* <input
                                  type="number"
                                  step="0.00001"
                                  placeholder="Cost"
                                  className="form-control height-25 p-0 p-l-5 rounded-0"
                                  onFocus={(e) => {
                                    e.target.placeholder = "";
                                    e.target.style.color = "black";
                                  }}
                                  onBlur={(e) => {
                                    e.target.placeholder = "Cost";
                                  }}
                                  style={{ color: "var(--primary-25)" }}
                                  {...register("cost")}
                                /> */}
                                  <input
                                    type="text"
                                    inputMode="decimal"
                                    placeholder="Cost"
                                    className="form-control height-25 p-0 p-l-5 rounded-0 text-start"
                                    style={{ color: "var(--primary-25)" }}
                                    value={
                                      costFocused
                                        ? `$ ${costValue ?? ""}`
                                        : costValue !== "" && costValue !== null
                                          ? inputCurrencyFormat2(costValue)
                                          : ""
                                    }
                                    onFocus={(e) => {
                                      e.target.placeholder = "";
                                      e.target.style.color = "black";

                                      // Save current value and clear input
                                      setPreviousCost(costValue);
                                      setValue("cost", "");
                                      setCostFocused(true);
                                    }}
                                    onChange={(e) => {
                                      let value = e.target.value.replace(/[^0-9.]/g, "");

                                      if ((value.match(/\./g) || []).length > 1) {
                                        value = value.substring(0, value.lastIndexOf("."));
                                      }

                                      if (value.includes(".")) {
                                        const parts = value.split(".");
                                        if (parts[1].length > 4) {
                                          parts[1] = parts[1].substring(0, 4);
                                        }
                                        value = parts.join(".");
                                      }

                                      setValue("cost", value);
                                    }}
                                    onBlur={(e) => {
                                      e.target.placeholder = "Cost";
                                      setCostFocused(false);

                                      // If user didn't type anything, restore previous value
                                      if (!costValue) {
                                        setValue("cost", previousCost);
                                      }
                                    }}
                                  />
                                </div>
                              </div>

                              <div className="d-flex mx-0 align-items-center custom-margin-bottom">
                                <div
                                  className="d-flex p-l-5 align-items-center justify-content-start"
                                  style={{
                                    color: "var(--primary-25)",
                                    fontWeight: "600",
                                    // width: "135px",
                                  }}
                                >
                                  Ready:
                                </div>
                                <div className="flex-g-1 height-25 p-l-5 p-r-5">
                                  <input
                                    type="date"
                                    placeholder="Ready (Date of Completion)"
                                    className="form-control height-25 p-0 p-l-5 rounded-0"
                                    onFocus={(e) => {
                                      e.target.placeholder = "";
                                      e.target.style.color = "black";
                                    }}
                                    onBlur={(e) => {
                                      e.target.placeholder = "Ready (Date of Completion)";
                                    }}
                                    style={{ color: "var(--primary-25)" }}
                                    {...register("completed")}
                                  />
                                </div>
                                <div
                                  className="d-flex p-l-5 align-items-center justify-content-start"
                                  style={{
                                    color: "var(--primary-25)",
                                    fontWeight: "600",
                                    // width: "135px",
                                  }}
                                >
                                  Requested:
                                </div>
                                <div className="flex-g-1 height-25 p-l-5 p-r-5">
                                  <input
                                    type="date"
                                    placeholder="Ready (Date of Completion)"
                                    className="form-control height-25 p-0 p-l-5 rounded-0"
                                    onFocus={(e) => {
                                      e.target.placeholder = "";
                                      e.target.style.color = "black";
                                    }}
                                    onBlur={(e) => {
                                      e.target.placeholder = "Ready (Date of Completion)";
                                    }}
                                    style={{ color: "var(--primary-25)" }}
                                    {...register("report_requested")}
                                  />
                                </div>

                                <div
                                  className="d-flex p-l-5 align-items-center justify-content-start"
                                  style={{
                                    color: "var(--primary-25)",
                                    fontWeight: "600",
                                    // width: "135px",
                                  }}
                                >
                                  Received:
                                </div>
                                <div className="flex-g-1 height-25 p-l-5 p-r-5">
                                  <input
                                    type="date"
                                    placeholder="Ready (Date of Completion)"
                                    className="form-control height-25 p-0 p-l-5 rounded-0"
                                    onFocus={(e) => {
                                      e.target.placeholder = "";
                                      e.target.style.color = "black";
                                    }}
                                    onBlur={(e) => {
                                      e.target.placeholder = "Ready (Date of Completion)";
                                    }}
                                    style={{ color: "var(--primary-25)" }}
                                    {...register("report_received")}
                                  />
                                </div>
                              </div>

                              <div className="w-100 m-t-5">
                                <CaseWorkerSelection
                                  panelLabel={reminderLabel}
                                  case_users={firmUsers?.slice(0, 3)}
                                  case_users1={firmUsers?.slice(3, 6)}
                                  otherUser={otherFirmUser}
                                  uniqueIdUsers={uniqueIdUsers}
                                  assignedUsers={assignedUsers}
                                  setAssignedUsers={setAssignedUsers}
                                  setUniqueIdUsers={setUniqueIdUsers}
                                  showOtherUsersModal={showOtherUsersModal}
                                  setShowOtherUsersModal={setShowOtherUsersModal}
                                />
                              </div>
                              {/* <div className="row mx-0 align-items-center custom-margin-bottom">
                              <div className="col-md-2 text-start">
                                <span className="d-inline-block text-grey text-nowrap">
                                  Report Number:
                                </span>
                              </div>
                              <div className="col-md-10">
                                <input
                                  type="text"
                                  placeholder="Enter Report Number"
                                  className="form-control"
                                  {...register("report_number")}
                                />
                              </div>
                            </div> */}

                              {/* <div className="row mx-0 align-items-center custom-margin-bottom">
                              <div className="col-md-2 text-start">
                                <span className="d-inline-block text-grey">Ready:</span>
                              </div>
                              <div className="col-md-10">
                                <input
                                  type="date"
                                  placeholder="Enter Date of Completion"
                                  className="form-control"
                                  {...register("completed")}
                                />
                              </div>
                            </div> */}
                              {/* <div className="row mx-0 align-items-center custom-margin-bottom">
                              <div className="col-md-2 text-start">
                                <span className="d-inline-block text-grey">Cost:</span>
                              </div>
                              <div className="col-md-10">
                                <input
                                  type="number"
                                  step="0.01"
                                  placeholder="Enter Cost"
                                  className="form-control"
                                  {...register("cost")}
                                />
                              </div>
                            </div> */}
                            </Col>
                          </Row>
                        </Tab.Pane>

                        {/* Report Taken By Completed */}
                        <Tab.Pane eventKey="report-taken-by">
                          <Row
                            style={{
                              minHeight: "350px",
                            }}
                            className="mx-0"
                          >
                            <Col md={12} className="p-0">
                              <div className="row mx-0 align-items-center custom-margin-bottom">
                                <div className="col-md-2 p-l-5 pe-0">
                                  <input
                                    type="text"
                                    placeholder="Title"
                                    className="form-control height-25 d-flex align-items-center p-l-5 p-0"
                                    {...register("title")}
                                    // {...register("contact_title")}
                                  />
                                </div>

                                <div className="col-md-5 p-l-5 pe-0">
                                  <input
                                    type="text"
                                    placeholder="First Name"
                                    className="form-control height-25 d-flex align-items-center p-l-5 p-0"
                                    {...register("reporter_firstname")}
                                    // {...register("contact_first_name")}
                                  />
                                </div>

                                <div className="col-md-5 p-l-5 p-r-5">
                                  <input
                                    type="text"
                                    placeholder="Last Name"
                                    className="form-control height-25 d-flex align-items-center p-l-5 p-0"
                                    {...register("reporter_lastname")}
                                    // {...register("contact_last_name")}
                                  />
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </Tab.Pane>
                      </Tab.Content>
                    </fieldset>
                  </div>
                  <div
                    className="d-flex justify-content-between "
                    style={{
                      padding: "5px",
                    }}
                  >
                    <Button
                      className="button-padding-footer-new-provider height-25 d-flex align-items-center justify-content-center"
                      variant="secondary"
                      onClick={handleClose}
                      type="button"
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="success"
                      className="button-padding-footer-new-provider height-25 d-flex align-items-center justify-content-center"
                      type="submit"
                    >
                      Save and Close
                    </Button>
                  </div>
                </Form>
              </Tab.Container>
            </div>
          </Modal.Body>
        </div>
      </Modal>
    </FormProvider>
  );
};

export default NewReportModal;
